import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter, Routes, Route } from 'react-router-dom'
import './index.css'
import CreateEvent from './pages/CreateEvent'
import EventView from './pages/EventView'
import EditEvent from './pages/EditEvent'
import MyPage from './pages/MyPage'
import About from './pages/About'
import Demo from './pages/Demo'
import Import from './pages/Import'

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <BrowserRouter>
      <Routes>
        <Route path="/" element={<CreateEvent />} />
        <Route path="/e/:id" element={<EventView />} />
        <Route path="/e/:id/edit" element={<EditEvent />} />
        <Route path="/me" element={<MyPage />} />
        <Route path="/about" element={<About />} />
        <Route path="/demo" element={<Demo />} />
        <Route path="/import" element={<Import />} />
      </Routes>
    </BrowserRouter>
  </React.StrictMode>
)
